import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';        // ← Your main design
import './index.css';       // ← Optional resets (keep if you want)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);